import { Directive } from '@angular/core';
import type { NavItem } from './models';

/**
 * Context interface for nav list template.
 * Provides typed access to navigation items and handlers within the template.
 */
export interface NavListTemplateContext {
    /** The navigation items array (accessed via `let-items`) */
    $implicit?: never;
    /** Function returning the effective expanded state */
    isEffectiveExpanded: () => boolean;
    /** Click handler for navigation items */
    onNavItemClick: (item: NavItem) => void;
}

@Directive({
    selector: 'ng-template[qpxNavListTpl]',
})
export class NavListTemplate {
    static ngTemplateContextGuard(
        dir: NavListTemplate,
        ctx: unknown
    ): ctx is NavListTemplateContext {
        return true;
    }
}
